module.exports = __webpack_public_path__ + "assets/img/create-plain.5feeee18.png";